
export const COMPANY = {
    legalName: "IT Creator SLTS d.o.o.",
    brandName: "BusGo",
    activity: "Računarsko programiranje",
    activityCode: "6201",
    registrationNumber: "21033626",
    taxId: "108609808",
    address: "Mileševska 36A",
    city: "11000 Beograd",
    country: "Srbija",
    web: "https://busgo.travel",
    phone: "+381 11 4444 577",
    email: "office@it-creator.rs",
    // Kontakt korisničke podrške — tel bez razmaka je za tel: linkove.
    supportPhone: "+381 11 4444 588",
    supportPhoneTel: "+381114444588",
    supportEmail: "podrska@it-creator.rs",
    isVatPayer: true,
};

export const companyFullAddress = `${COMPANY.address}, ${COMPANY.city}, ${COMPANY.country}`;
